import apiClient from "@/lib/api-client"
import type { ChangePasswordRequest, LoginRequest, Me } from "@/types/auth"

export const authApi = {
  login: (data: LoginRequest) => apiClient.post<Me>("/auth/login", data).then((r) => r.data),
  logout: () => apiClient.post<void>("/auth/logout").then((r) => r.data),
  getMe: () => apiClient.get<Me>("/auth/me").then((r) => r.data),
  changePassword: (data: ChangePasswordRequest) => apiClient.post<void>("/auth/change-password", data).then((r) => r.data),
  moduleAccess: (module: string) => apiClient.post<void>("/auth/module-access", { module }).then((r) => r.data),
}
